import { Button, Stack } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import {
  selectedFilteredDeckIds,
  selectedFilteredPaintRegionIds,
  applyFilters,
  selectedTemplateFiltersState,
  selectedFilteredWorkpackIds,
} from '@/components/Analysis/state';

type Props = {
  onClear?: () => void;
};

export const FilterActions = ({ onClear }: Props) => {
  const setSelectedTemplateFilters = useSetAtom(selectedTemplateFiltersState);
  const setSelectedDeckIds = useSetAtom(selectedFilteredDeckIds);
  const setSelectedPaintRegionIds = useSetAtom(selectedFilteredPaintRegionIds);
  const setApplyFilters = useSetAtom(applyFilters);
  const setSelectedWorkpackIds = useSetAtom(selectedFilteredWorkpackIds);
  const clearFilters = useCallback(() => {
    setSelectedTemplateFilters([]);
    setSelectedDeckIds([]);
    setSelectedPaintRegionIds([]);
    setSelectedWorkpackIds([]);
    setApplyFilters(true);
    if (onClear) {
      onClear();
    }
  }, [
    onClear,
    setApplyFilters,
    setSelectedDeckIds,
    setSelectedPaintRegionIds,
    setSelectedTemplateFilters,
    setSelectedWorkpackIds,
  ]);

  return (
    <Stack data-testid="filter-actions" direction="row" spacing={2}>
      {false && (
        <Button sx={{ fontSize: '1rem' }} startIcon={<SaveIcon />} id="save-query-button">
          Save Query
        </Button>
      )}
      <Button
        id="clear-query-button"
        data-testid="clear-query-button"
        sx={{ fontSize: '1.2rem', textTransform: 'none' }}
        startIcon={<CancelIcon />}
        onClick={() => clearFilters()}
      >
        Clear Query
      </Button>
    </Stack>
  );
};
